import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Stack,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import KsbDialogActions from "../../../2_ksbHub/components/KsbDialogActions";

const AVAILABLE_JAHRGAENGE = [
  "1. Klassen",
  "2. Klassen",
  "3. Klassen",
  "4. Klassen",
  "5. Klassen",
  "6. Klassen",
];

export default function AddSondertagDialog({
  open,
  onClose,
  onSave,
  initialData,
  sondertagTemplates,
}) {
  const [label, setLabel] = useState("");
  const [time, setTime] = useState("");
  const [templateId, setTemplateId] = useState(null);

  const [jahrgaenge, setJahrgaenge] = useState([]);
  const [error, setError] = useState("");

  const isEditMode = !!initialData;

  useEffect(() => {
    setError("");

    if (initialData) {
      setLabel(initialData.label);
      setTime(initialData.time);

      setJahrgaenge(
        AVAILABLE_JAHRGAENGE.map((title) => {
          const existing = initialData.jahrgaenge?.find(
            (j) => j.title === title,
          );

          return {
            id: existing?.id ?? null,
            title,
            selected: !!existing,
            existing: !!existing,
          };
        }),
      );

      setTemplateId(initialData.templateId ?? null);
    } else {
      setLabel("");
      setTime("");

      setJahrgaenge(
        AVAILABLE_JAHRGAENGE.map((title) => ({
          id: null,
          title,
          selected: true,
          existing: false,
        })),
      );

      setTemplateId(sondertagTemplates?.[0]?.id ?? null);
    }
  }, [initialData, open, sondertagTemplates]);

  const handleSave = async () => {
    try {
      setError("");

      const deletedJahrgaenge = jahrgaenge
        .filter((j) => j.existing && !j.selected)
        .map((j) => j.id);

      const addedJahrgaenge = jahrgaenge
        .filter((j) => !j.existing && j.selected)
        .map((j) => ({
          title: j.title,
        }));

      await onSave({
        id: initialData?.id || `sondertag-${Date.now()}`,
        label,
        time,
        templateId,
        deletedJahrgaenge,
        addedJahrgaenge,
      });

      onClose();
    } catch (err) {
      console.error(err);

      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Fehler beim Speichern.",
      );
    }
  };

  const deletedJahrgaenge = jahrgaenge.filter((j) => j.existing && !j.selected);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        {isEditMode ? "Sondertag bearbeiten" : "Neuer Sondertag"}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={1}>
          {error && <Typography color="error">{error}</Typography>}

          <TextField
            label="Bezeichnung (z.B. Montag)"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            fullWidth
          />

          <TextField
            label="Datum (z.B. 23.05.2027)"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            fullWidth
          />

          <Stack spacing={1}>
            <Typography variant="subtitle2">
              Jahrgänge für diesen Sondertag
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Aktiviere die gewünschten Jahrgänge. Deaktivierte Jahrgänge werden
              entfernt. Jahrgänge mit bestehenden Reservationen können nicht
              gelöscht werden.
            </Typography>

            {jahrgaenge.map((j) => (
              <FormControlLabel
                key={j.title}
                control={
                  <Checkbox
                    checked={j.selected}
                    onChange={() =>
                      setJahrgaenge((prev) =>
                        prev.map((item) =>
                          item.title === j.title
                            ? {
                                ...item,
                                selected: !item.selected,
                              }
                            : item,
                        ),
                      )
                    }
                  />
                }
                label={j.title}
              />
            ))}
          </Stack>

          <TextField
            select
            label="Vorlage"
            value={templateId ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              setTemplateId(value ? Number(value) : null);
            }}
            fullWidth
          >
            {sondertagTemplates?.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.label}
              </MenuItem>
            ))}

            <MenuItem value="">Keine Vorlage benutzen</MenuItem>
          </TextField>
        </Stack>
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSave}
        confirmLabel="Speichern"
        confirmDisabled={!label.trim()}
        confirmConfirm={
          deletedJahrgaenge.length > 0
            ? {
                title: "Jahrgänge löschen?",
                message: `Du bist daran, ${deletedJahrgaenge.length} Jahrgang/Jahrgänge zu löschen. Alle zugehörigen Angebote ohne Reservationen werden ebenfalls entfernt.`,
              }
            : undefined
        }
      />
    </Dialog>
  );
}
